// src/modules/components/reports/calls/CallTypeChip.js
import React from "react";
import { Chip } from "@mui/material";
import {
  CallReceived,
  CallMade,
  Call,
  PhoneCallback,
} from "@mui/icons-material";

const CallTypeChip = ({ record }) => {
  const getCallTypeProps = (type) => {
    if (!type) return { icon: <PhoneCallback />, color: 'default', label: 'Unknown' };
    
    const typeLower = type.toLowerCase();
    
    switch (typeLower) {
      case 'incoming':
        return { icon: <CallReceived />, color: 'success', label: 'Incoming' };
      case 'outgoing':
        return { icon: <CallMade />, color: 'primary', label: 'Outgoing' };
      case 'internal':
        return { icon: <Call />, color: 'secondary', label: 'Internal' };
      default:
        return { icon: <PhoneCallback />, color: 'default', label: type };
    }
  };

  const props = getCallTypeProps(record?.callType);
  
  return (
    <Chip
      icon={props.icon}
      label={props.label}
      color={props.color}
      size="small"
      variant="outlined"
    />
  );
};

export default CallTypeChip;